const IMPORT_STATUS = Object.freeze({
    CREATED: 'created',
    PENDING: 'pending',
    SUCCESS: 'success',
    FAILURE: 'failure',
});

const IMPORT_ACTIONS = Object.freeze({
    CREATE: 'create',
    UPDATE: 'update',
});

const IMPORT_ACTION_VALUES = Object.freeze(Object.values(IMPORT_ACTIONS));

const IMPORT_CHUNK_ITEM_COUNT = 50;

module.exports = {
    IMPORT_STATUS,
    IMPORT_ACTIONS,
    IMPORT_ACTION_VALUES,
    IMPORT_CHUNK_ITEM_COUNT,
};
